/**
 * @file skeleton.component.tsx
 * @path packages/ui/src/skeleton.component.tsx
 * @description
 */

import { cn } from "@sirbastians/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  )
}

export { Skeleton }
